export interface UserTagPresentation {
  key: string;
  label: string;
}

const USER_TAGS = new Map<string, UserTagPresentation>([
  ["user", { key: "user", label: "Farmer/Customer" }],
  ["farmer", { key: "farmer", label: "Farmer/Customer" }],
  ["member", { key: "member", label: "Member" }],
  ["not member", { key: "not-member", label: "Not Member" }],
  ["agent", { key: "agent", label: "Agent" }],
  ["admin", { key: "admin", label: "Admin" }],
  [
    "agronomist_agent",
    { key: "agronomist_agent", label: "Agronomist Agent" },
  ],
  [
    "agronomist_admin",
    { key: "agronomist_admin", label: "Agronomist Admin" },
  ],
  ["dairy", { key: "dairy", label: "Dairy" }],
]);

export function isAgentAccount(user: { userType: string; agentEnabled?: boolean }): boolean {
  return user.userType === "agent" || (user.userType === "admin" && user.agentEnabled === true);
}

export function matchesAccountRole(accountRole: string, filter: string, agentEnabled = false): boolean {
  if (filter === "all") return true;
  if (filter === "farmer") return ["farmer", "user"].includes(accountRole);
  if (filter === "agent") return isAgentAccount({ userType: accountRole, agentEnabled });
  return accountRole === filter;
}

export function getUserTagPresentation(
  value: unknown,
  agentEnabled = false,
): UserTagPresentation | null {
  if (typeof value !== "string" || !value.trim()) {
    return null;
  }

  if (value.trim().toLowerCase() === "admin" && agentEnabled) return { key: "admin", label: "Admin / Agent" };
  return USER_TAGS.get(value.trim().toLowerCase()) || null;
}
